import { render, staticRenderFns } from "./CTextBlock.vue?vue&type=template&id=1482c39b&scoped=true&"
import script from "./CTextBlock.vue?vue&type=script&lang=js&"
export * from "./CTextBlock.vue?vue&type=script&lang=js&"
import style0 from "./CTextBlock.vue?vue&type=style&index=0&id=1482c39b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1482c39b",
  null
  
)

export default component.exports